import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  Pressable,
} from "react-native";
import { VehicleList } from "../../Constants/Data";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import useAppNavigation from "../../Routes/useAppNavigation";
// import { useTranslation } from "react-i18next";

const { width, height } = Dimensions.get("window");
const DispatchCustomer = () => {
  const navigation = useAppNavigation();
  const [DotModal, setDotModal] = useState(false);
  const [modalVisibleone, setModalVisibleone] = useState(false);

  // Auto-open the "Delete" confirmation modal on its PDF route.
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname ===
      "/DispatchManagement/DispatchCustomer/RemoveCustomerDetails/Delete"
    ) {
      setModalVisibleone(true);
    }
  }, [location.pathname]);

  const [select, setSelected] = useState(0);
  const [activeIndex, setActiveIndex] = useState(1);
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const handleTextPress = (index) => {
    setActiveIndex(index);
  };
  return (
    <SafeAreaView style={styles.MainView}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "white",
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 10 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View style={Appstyles.fullAlignment}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15, resizeMode: "contain" }}
            />
          </TouchableOpacity>
          <Text
            style={{
              color: AppColors.brown1,
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,
              marginLeft: 20,
            }}
          >
            Dispatch Customer
          </Text>
        </View>

        <View style={{ flexDirection: "row" }}>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("AddDispatchCustomer")}
          >
            <Image
              source={AppImages.Plus}
              style={{ width: 18, height: 18, marginLeft: 15 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          backgroundColor: AppColors.white,
          marginTop: 20,
        }}
      >
        <View
          style={{
            flexDirection: "row",

            alignItems: "center",

            marginHorizontal: 20,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",

              marginTop: 20,
              // width: "100%",
              height: height * 0.07,
              borderRadius: 10,
              borderColor: AppColors.sandal,
              //  height: height * 0.07,
              borderWidth: 1,
              height: 45,
              flex: 1,
            }}
          >
            <TextInput
              placeholder={t("common:translation.Search Customer....")}
              placeholderTextColor="#ACACAC80"
              style={{
                fontSize: 12,
                // alignItems: "center",
                fontFamily: AppFonts.OverpassMedium,
                width: "90%",
                paddingLeft: 13,
              }}
            />
            <View style={styles.vee}>
              <Image
                source={AppImages.search}
                style={{
                  width: 17,
                  height: 17,
                  resizeMode: "contain",
                  marginRight: 11,
                }}
                resizeMode="contain"
              />
            </View>
          </View>

          {/* <TouchableOpacity style={styles.too}></TouchableOpacity> */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 13,
              marginTop: 10,
            }}
          >
            <Image
              source={AppImages.Import}
              style={{ height: 20, width: 22 }}
              resizeMode="contain"
            />

            <Image
              source={AppImages.Shareit}
              style={{ height: 25, width: 23, marginLeft: 16 }}
              resizeMode="contain"
            />
          </View>
        </View>
        <View style={{ marginTop: 20 }} />
        <FlatList
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          ListHeaderComponent={<View style={{}}></View>}
          ListFooterComponent={() => <View style={{ padding: 70 }} />}
          data={VehicleList}
          renderItem={({ item }) => (
            <View
              style={{
                backgroundColor: "#F6EFE9",
                marginHorizontal: 20,
                //paddingHorizontal: 20,
                paddingVertical: 14,
                borderRadius: 10,
                marginBottom: 20,
              }}
            >
              <View
                style={[
                  styles.FlatImg,
                  { borderBottomWidth: 1, borderBottomColor: "#9C49001A" },
                ]}
              >
                <View
                  style={{
                    flexDirection: "row",
                    marginLeft: 20,
                    paddingBottom: 14,
                    //  alignItems: "center",
                  }}
                >
                  <Image
                    source={AppImages.Boycircle}
                    style={{ width: 50, height: 46 }}
                    resizeMode="contain"
                  />
                  <View style={{ marginLeft: 29 }}>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                      }}
                    >
                      {t("common:translation.Customer Name")}{" "}
                    </Text>
                    <Text
                      style={{
                        color: "#8F4300",
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                        marginTop: 3,
                      }}
                    >
                      Jhon Doe
                    </Text>
                  </View>
                </View>
                <TouchableOpacity onPress={() => setDotModal(true)}>
                  <Image
                    source={item.Dot}
                    style={{
                      width: 20,
                      height: 20,
                      // alignItems: "center",
                      marginRight: 20,
                      marginTop: -10,
                    }}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
              </View>
              <View style={{ marginHorizontal: 20 }}>
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 10,
                  }}
                >
                  <Text
                    style={{
                      color: "#8F430080",
                      fontSize: 12,
                      fontFamily: AppFonts.OverpassRegular,
                      width: "50%",
                    }}
                  >
                    Customer Code
                  </Text>
                  <Text
                    style={{
                      color: "#8F430080",
                      fontSize: 12,
                      fontFamily: AppFonts.OverpassRegular,
                    }}
                  >
                    Customer Email{" "}
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 5,
                  }}
                >
                  <Text
                    style={{
                      color: "#8F4300",
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassSemiBold,
                      // marginTop: 3,
                      width: "50%",
                    }}
                  >
                    100{" "}
                  </Text>
                  <Text
                    style={{
                      color: "#8F4300",
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassSemiBold,
                      // marginTop: 3,
                    }}
                  >
                    jhondoe@gmail.com{" "}
                  </Text>
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 10,
                  }}
                >
                  <Text
                    style={{
                      color: "#8F430080",
                      fontSize: 12,
                      fontFamily: AppFonts.OverpassRegular,
                      width: "50%",
                    }}
                  >
                    Contact Number{" "}
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 5,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassSemiBold,
                      // marginTop: 3,
                      width: "50%",
                    }}
                  >
                    99999 99999{" "}
                  </Text>
                </View>
              </View>
            </View>
          )}
        />
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
          <View
            style={{ backgroundColor: "#766C8E", flex: 1, opacity: 0.55 }}
          ></View>
        </TouchableWithoutFeedback>
        <View
          style={{
            width: "100%",
            backgroundColor: "white",

            borderTopRightRadius: 16,
            borderTopLeftRadius: 16,
            position: "absolute",
            bottom: 0,
            padding: 20,
          }}
        >
          <TouchableOpacity
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <Image
              source={AppImages.LineBar}
              style={{ width: 40, height: 2.5 }}
            />
          </TouchableOpacity>
          <TouchableWithoutFeedback
            onPress={() => [
              handleTextPress(1),
              navigation.navigate("DispatchCustomerViewDetails"),
            ]}
          >
            <View
              style={
                {
                  //  alignItems: "center",
                  //  justifyContent: "center",
                  //  marginLeft: 10,
                  //   flexDirection:"row"
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 1 && styles.activeText]}
              >
                View{" "}
              </Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback
            onPress={() => [
              handleTextPress(2),
              navigation.navigate("EditDispatchCustomer"),
            ]}
          >
            <View
              style={
                {
                  //  alignItems: "center",
                  //  justifyContent: "center",
                  //  marginLeft: 10,
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 2 && styles.activeText]}
              >
                Edit{" "}
              </Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback
            onPress={() => [
              handleTextPress(3),
              setModalVisibleone(true),
              setDotModal(false),
            ]}
          >
            <View
              style={
                {
                  // alignItems: "center",
                  // justifyContent: "center",
                  //  marginLeft: 10,
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 3 && styles.activeText]}
              >
                Delete{" "}
              </Text>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </Modal>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisibleone}
        onRequestClose={() => {
          setModalVisibleone(!modalVisibleone);
        }}
      >
        <Pressable
          onPress={() => setModalVisibleone(false)}
          style={{
            flex: 1,
            //backgroundColor: "rgba(0, 0, 0, 0.25)",
            backgroundColor: "rgba(66, 31, 0, 0.55)",
            alignItems: "center",
            justifyContent: "center",
            // opacity:0.55
          }}
        >
          <View
            style={{
              backgroundColor: AppColors.white,
              width: "90%",
              padding: 20,
              borderRadius: 15,
              margin: 20,
            }}
          >
            <View style={{}}>
              <TouchableOpacity
                onPress={() => navigation.navigate("Changelogo")}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottomColor: AppColors.sandal,
                    borderBottomWidth: 1,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontFamily: AppFonts.OverpassRegular,
                      fontSize: 20,
                      marginBottom: 20,
                    }}
                  >
                    Delete Dispatch Customer
                  </Text>
                  <TouchableOpacity onPress={() => setModalVisibleone(false)}>
                    <Image
                      source={AppImages.cross}
                      style={{ height: 13, width: 12, marginBottom: 20 }}
                    />
                  </TouchableOpacity>
                </View>
              </TouchableOpacity>
              <View
                style={{
                  borderBottomColor: AppColors.sandal,
                  borderBottomWidth: 1,
                }}
              >
                <Text
                  style={{
                    color: AppColors.brown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 14,
                    width: "100%",
                    marginTop: 20,
                    marginBottom: 20,
                  }}
                >
                  Are you sure you want to Delete Dispatch Customer ?
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  marginTop: 20,
                }}
              >
                <TouchableOpacity
                  onPress={() => setModalVisibleone(false)}
                  style={{
                    width: "30%",
                    height: 44,
                    borderColor: AppColors.brown,
                    borderWidth: 1,
                    borderRadius: 15,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown,
                      fontFamily: AppFonts.OverpassSemiBold,
                      fontSize: 14,
                    }}
                  >
                    Cancel
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => setModalVisibleone(false)}
                  style={{
                    width: "30%",
                    height: 44,
                    backgroundColor: AppColors.brown,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 15,
                    marginLeft: 20,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.white,
                      fontFamily: AppFonts.OverpassSemiBold,
                      fontSize: 14,
                    }}
                  >
                    Delete
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
    </SafeAreaView>
  );
};

export default DispatchCustomer;
const styles = StyleSheet.create({
  MainView: { backgroundColor: AppColors.sandal, flex: 1 },
  SecMain: { backgroundColor: AppColors.white, marginHorizontal: 20 },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    marginTop: 20,
    width: "100%",
    height: height * 0.07,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "90%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    height: height * 0.07,
    borderWidth: 1,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  Flatmain: {
    marginTop: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    margin: 10,
    marginLeft: 20,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { marginLeft: 20 },
  FlatTxtSec: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  LineBars: {
    width: "100%",
    right: 20,
    // position: 'absolute',
    borderTopColor: AppColors.brown,
    borderTopWidth: 0.7,
    opacity: 0.099,
    marginTop: 10,
  },
  CopyText: {
    fontSize: 14,
    marginTop: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "50%",
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
    fontWeight: "700",
  },
  NonCopy: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    // fontWeight: '700',
  },
  Row: { flexDirection: "row", flex: 1, alignItems: "center" },

  Textt: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
  },
});
